import React, { useId } from 'react';
import { useFormContext } from 'react-hook-form';

import { cn } from '@epoch-ui/lib/utils';
import { Checkbox, CheckboxProps } from '@epoch-ui/components/Checkbox';

import {
  FormField,
  FormControl,
  FormDescription,
  FormLabel,
  FormItem,
  FormMessage
} from '../../form';

export interface CheckboxFieldProps extends CheckboxProps {
  label?: string | React.ReactNode | React.ReactNode[];
  description?: string | React.ReactNode | React.ReactNode[];
  error?: boolean;
}

export const CheckboxField = React.forwardRef<HTMLDivElement, CheckboxFieldProps>(
  ({ name, label, description, className, onCheckedChange, ...props }, ref) => {
    const formCtx = useFormContext();
    const id = useId();
    return (
      <FormField
        control={formCtx.control}
        name={name || id}
        render={({ field, fieldState }): JSX.Element => (
          <FormItem
            ref={ref}
            className={cn('tw-mt-4 tw-flex tw-items-center tw-gap-3 ', className)}
          >
            <FormControl>
              <Checkbox
                className="tw-mt-0"
                checked={field.value}
                onCheckedChange={(value) => {
                  field.onChange(value);
                  onCheckedChange?.(value);
                }}
                error={!!fieldState.error}
                {...props}
                {...field}
              />
            </FormControl>
            {label && (
              <div
                className={cn(
                  'tw-mb-0 tw-flex tw-flex-col tw-gap-1',
                  props.disabled && 'tw-opacity-40'
                )}
              >
                <FormLabel>{label}</FormLabel>
                {description && <FormDescription className="tw-m-0">{description}</FormDescription>}
              </div>
            )}
            <FormMessage />
          </FormItem>
        )}
      />
    );
  }
);
